import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';
import { IPromoState } from '../../types/promo';

const initialState: IPromoState = {
  isOpen: false,
  promo: null,
};

/* istanbul ignore next */
const promoSlice = createSlice({
  initialState,
  name: 'promo',
  reducers: {
    openPromo: (state, action: PayloadAction<IPromoInfo>) => {
      state.promo = action.payload;
      state.isOpen = true;
    },
    closePromo: state => {
      state.promo = null;
      state.isOpen = false;
    },
  },
});

export const {
  reducer: promoReducer,
  actions: { openPromo, closePromo },
} = promoSlice;
